import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from './services/authentication.service';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import * as moment from 'moment';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const user = this.authenticationService.currentUserValue;
    const token = this.authenticationService.currentTokenValue;
    const isAuthenticated = user && token;
    const isApiUrl = req.url.startsWith(environment.api.host);

    // Get local and UTC time using moment
    const localTime = moment().format('YYYY-MM-DD HH:mm:ss');
    const utcTime = moment().utc().format('YYYY-MM-DD HH:mm:ss');

    let headers: any = {
      'x-client-local-time': localTime,
      'x-client-utc-time': utcTime,
    };

    if (isAuthenticated && isApiUrl) {
      headers['authorization'] = 'Bearer ' + token;
    }

    req = req.clone({ setHeaders: headers });

    return next.handle(req).pipe(
      tap(
        () => {},
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status !== 401) {
              return;
            }
            this.authenticationService.deauthoriseUser();
          }
        }
      )
    );
  }
}
